import { render, staticRenderFns } from "./weekly-goal.vue?vue&type=template&id=2d06c0dc&"
import script from "./weekly-goal.vue?vue&type=script&lang=js&"
export * from "./weekly-goal.vue?vue&type=script&lang=js&"
import style0 from "./weekly-goal.vue?vue&type=style&index=0&id=2d06c0dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports